import { atom } from 'jotai';

import type { ExperimentsResponse } from './consts';

export const experimentsAtom = atom<ExperimentsResponse>({ groups: [] });
